export const AddFileIcon = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.8334 2.83325H8.50008C7.74863 2.83325 7.02797 3.13176 6.49661 3.66312C5.96526 4.19447 5.66675 4.91514 5.66675 5.66659V28.3333C5.66675 29.0847 5.96526 29.8054 6.49661 30.3367C7.02797 30.8681 7.74863 31.1666 8.50008 31.1666H25.5001C26.2515 31.1666 26.9722 30.8681 27.5035 30.3367C28.0349 29.8054 28.3334 29.0847 28.3334 28.3333V11.3333L19.8334 2.83325Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.8333 2.83325V11.3333H28.3333'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 25.5V17'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.75 21.25H21.25'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
